import { render } from "./ProdAction.vue?vue&type=template&id=5000f688&scoped=true"
import script from "./ProdAction.vue?vue&type=script&lang=js"
export * from "./ProdAction.vue?vue&type=script&lang=js"

import "./ProdAction.vue?vue&type=style&index=0&id=5000f688&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5000f688"]])

export default __exports__